import React from 'react';

export default function PrivacyPolicy() {
  return (
    <section className="pt-28 pb-32 px-4 text-white bg-[#060b29] min-h-screen">
      <div className="max-w-4xl mx-auto text-center">
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-30">Privacy Policy</h1>

        {/* Content */}
        <div className="space-y-8 text-left text-gray-300" style={{ fontSize: '20px' }}>
          <p>
            At <strong className="text-white">PipPlus Tech</strong>, your privacy matters. We collect personal and usage data (like name, contact info, and financial inputs)
            to provide and improve our platform. Your information helps us deliver features, communicate with you, and comply with legal requirements.
          </p>

          <p>
            <strong className="text-white">We do not sell your personal data.</strong> We may share it with trusted service providers or when legally required.
            We use security measures to protect your information but cannot guarantee complete security.
          </p>

          <p>
            You can access, update, or request deletion of your data by contacting us.
          </p>

          <p>
            We may update this policy from time to time. Continued use of Pipplus means you accept any changes.
          </p>

          <p>
            If you have any questions about this Privacy Policy, feel free to reach out to us directly.
          </p>
        </div>
      </div>
    </section>
  );
}
